var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedlessons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 29.0625H4.6875C3.65203 29.0625 2.8125 28.223 2.8125 27.1875C2.8125 26.152 3.65203 25.3125 4.6875 25.3125H26.25V29.0625Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 1.875V25.0955C3.31031 24.6488 3.96609 24.375 4.6875 24.375H5.625V0.9375H3.75C3.2325 0.9375 2.8125 1.3575 2.8125 1.875Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 0.9375H6.5625V24.375H26.25H27.1875V23.4375V1.875C27.1875 1.3575 26.7675 0.9375 26.25 0.9375Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 24.375V1.875C28.125 0.838594 27.2864 0 26.25 0H3.75C2.71359 0 1.875 0.838594 1.875 1.875V27.1875C1.875 28.7405 3.13453 30 4.6875 30H27.6562C27.9155 30 28.125 29.7905 28.125 29.5312C28.125 29.272 27.9155 29.0625 27.6562 29.0625H27.1875V25.3125C27.705 25.3125 28.125 24.8925 28.125 24.375ZM2.8125 1.875C2.8125 1.3575 3.2325 0.9375 3.75 0.9375H5.625V24.375H4.6875C3.96609 24.375 3.31031 24.6488 2.8125 25.0955V1.875ZM26.25 29.0625H4.6875C3.65203 29.0625 2.8125 28.223 2.8125 27.1875C2.8125 26.152 3.65203 25.3125 4.6875 25.3125H26.25V29.0625ZM26.25 24.375H6.5625V0.9375H26.25C26.7675 0.9375 27.1875 1.3575 27.1875 1.875V23.4375V24.375H26.25Z",
    fill: "#394240"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1562 12.1875H10.7812C10.522 12.1875 10.3125 12.397 10.3125 12.6562C10.3125 12.9155 10.522 13.125 10.7812 13.125H20.1562C20.4155 13.125 20.625 12.9155 20.625 12.6562C20.625 12.397 20.4155 12.1875 20.1562 12.1875Z",
    fill: "#394240"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 9.375H10.7812C10.522 9.375 10.3125 9.58453 10.3125 9.84375C10.3125 10.103 10.522 10.3125 10.7812 10.3125H22.9688C23.228 10.3125 23.4375 10.103 23.4375 9.84375C23.4375 9.58453 23.228 9.375 22.9688 9.375Z",
    fill: "#394240"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7812 7.5H16.4062C16.6655 7.5 16.875 7.29047 16.875 7.03125C16.875 6.77203 16.6655 6.5625 16.4062 6.5625H10.7812C10.522 6.5625 10.3125 6.77203 10.3125 7.03125C10.3125 7.29047 10.522 7.5 10.7812 7.5Z",
    fill: "#394240"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M2.8125 1.875V25.0955C3.31031 24.6488 3.96609 24.375 4.6875 24.375H5.625V0.9375H3.75C3.2325 0.9375 2.8125 1.3575 2.8125 1.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedlessons);
export default __webpack_public_path__ + "static/media/Selectedlessons.4e7b48f6248a306d3bb266b3cfef5d83.svg";
export { ForwardRef as ReactComponent };